export default ($axios, pubId) => (resource) => ({
    getDomain() {
      const protocol = window.location.protocol
      const domain = window.location.hostname
      return domain === 'localhost' ? $axios.defaults.baseURL : `${protocol}//${domain}`
    },
    getMainConfig() {
      const url = `/content-api/${pubId}/localization/mainConfig`
      return $axios.get(url).then((result) => result.data)
    },
    getHotel(backCode) {
      const url = `/content-api/${pubId}/hotels/${backCode}`
      return $axios.get(url).then((result) => {
        return result.data
      })
    },
    getLabels() {
      const url = `/content-api/${pubId}/allLabels`
      return $axios.get(url).then((result) => result.data)
    },
    getContentPage(pageId) {
      const url = `/content-api/${pubId}/page/${pageId}`
      return $axios.get(url).then((result) => result.data)
    },
    getKeywords(categoryId) {
      const url = `/content-api/${pubId}/taxonomy/${categoryId}/keywords?sortOrder=3`
      return $axios.get(url).then((result) => result.data)
    },
    getKeywordsChildren(categoryId) {
      const url = `/content-api/${pubId}/taxonomy/${categoryId}/keywords/children`
      return $axios.get(url).then((result) => result.data)
    },
    getPromotionData(promotionId) {
      const domain = this.getDomain()
      const url = `${domain}/content-api/${pubId}/read-promotion?metaValue=${promotionId}`
      return $axios.get(url).then((result) => result.data)
    },
    getDestination(locale) {
      const domain = this.getDomain()
      const url = `${domain}/${locale}/resources/jsonDestinations.txt`
      return $axios.get(url).then((result) => result.data)
    },
    getLiveLocalData(id) {
      const url = `/content-api/${pubId}/read-live-local?metaValue=${id}`
      return $axios.get(url).then((result) => {
        return result.data
      })
    }
  })
  